<div class="status-modal">
  <div class="status-modal__header">
    <button mat-icon-button (click)="onClose()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="status-modal__content">
    <app-icon class="icon" [icon]="icon" />
    <h3 class="status-modal__title">
      {{ data.title | translate }}
    </h3>
    <p class="status-modal__description">
      {{ data.description | translate }}
    </p>
  </div>

  <div class="status-modal__actions">
    <button class="status-modal__actions--close" (click)="onClose()">
      {{ 'user-profile.security.actionButtons.close' | translate }}
    </button>
  </div>
</div>
